<template>
  <div class="zsxqy">
    <mt-header title="展商详情">
      <span slot="left" @click="()=>this.$router.push('/exhibitor')">
        <i class="iconfont icon-left"></i>
        返回
      </span>
    </mt-header>
    <div class="mintHeader"></div>
    <div class="detailContent">
      <div>
        <div class="zsbt">
          <div>
            <img :src="datas.corplogo_cn" alt="" />
          </div>
          <p>{{datas.corpname_cn}}</p>
        </div>
        <div class="abs">
          <h5>展商简介</h5>
          <p>{{datas.introduct_cn}}</p>
        </div>
        <div class="contact">
          <h5>联系方式</h5>
          <p><i class="iconfont icon-daohang"></i>地址：<span>{{datas.address_cn}}</span></p>
          <p><i class="iconfont icon-phone"></i>电话：<span>{{datas.phone}}</span></p>
          <p><i class="iconfont icon-gongwenchuanzhen"></i>传真：<span>{{datas.fax}}</span></p>
          <p><i class="iconfont icon-youxiang"></i>邮箱：<span>{{datas.email}}</span></p>
          <p><i class="iconfont icon-wangzhi2x"></i>网址：<span>{{datas.website}}</span></p>
        </div>
        <div class="product" v-if="xgcp.list.length">
          <h5>{{xgcp.name}}</h5>
          <ul>
            <li class="liItemR" v-for="item in xgcp.list" :key="item.id" @click="$router.push('/exhibit/details/'+item.id)">
              <div>
                <img :src="item.img_url" alt="" />
              </div>
              <p>{{item.proname_cn}}</p>
              <i class="iconfont collect" :class="like1?'icon-shoucang':'icon-shoucang_pre'" @click.stop="modifyLike('传入这一项','下标')"></i>
            </li>
          </ul>
        </div>
        
      </div>
    </div>
    <ul class="footer">
      <li @click="isCollect(datas.ocid)">
        <div>
          <img v-show="like1*1==1" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like.png" alt="" />
          <img v-show="like1*1==2" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/like_1.png" alt="" />
        </div>
        <span>收藏</span>
      </li>
      <li @click="isCorpApp(datas.ocid)">
        <i 
        class="iconfont collect icon-dianhua1" 
        :class="meet?'':'hue'"></i>
        <span>约见</span>
      </li>
      
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import { Header } from 'mint-ui';
Vue.component(Header.name, Header);
import "mint-ui/lib/header/style.css"
import { reqExhibitorDetail, reqCorpColl, reqCorpCollDo, reqCorpApp, reqCorpAppDo } from "../../../api";
export default {
  data () {
    return {
      like1:1,
      meet:0,
      list:[1,2,3,4,5,6,7,8,9,10],
      datas:{},//详情
      xgcp:{list:[],name:""},//相关产品
      id:Number,
      ocid:Number,
    }
  },
  mounted(){
    let id = this.$route.path.split('/')
    this.id=id[id.length-2]*1
    this.ocid=id[id.length-1]*1
    this.reqDetail(this.id)
    this.initCollect(this.ocid)
    this.initCorpApp(this.ocid)
  },
  methods:{
    modifyLike(item,i){
      console.log(item,i);
    },
    // 请求列表
    async reqDetail(id){
      const response = await reqExhibitorDetail(id)
      if(response.code==0){
          this.datas=response.resilt[0]
          this.xgcp = {
            name:"展品展示",
            list:response.resilt[1]
          }
      }else{
        this.$router.push("/")
      }
    },
    // 初始获取收藏状态
    async initCollect(ocid){
      const response = await reqCorpColl(ocid)
      if (response.code==0) {
        this.like1=response.is_coll
      }else{
        this.like1 = 1
      }
    },
    // 修改收藏状态
    async isCollect(ocid){
      const response = await reqCorpCollDo(ocid)
      if (response.code==0) {
        this.like1=response.is_coll
      }else{
        this.like1 = 1
      }
    },
    
    // 初始化约见状态++++
    async initCorpApp(ocid){
      const response = await reqCorpApp(ocid)
      if (response.code==0) {
        this.meet=response.is_coll
      }else{
        this.meet = 1
      }
    },
    // 修改约见状态
    async isCorpApp(ocid){
      const response = await reqCorpAppDo(ocid)
      if (response.code==0) {
        this.meet=response.is_coll
      }else{
        this.meet = 1
      }
    },
  }
}
</script>

<style scoped>
  .zstj{
    height: 100%;  
    background-color: #f3f3f3;  
  }
  .newListPage{
    height: 100%;
    background-color: white;
    overflow: hidden;
  }
  .mint-header{
    height: 40px;
    background-color: #008baf;
  }
  .detailContent{
    height: calc(100vh - 90px);
    overflow-y: auto;
    /* overflow: hidden; */
  }
  .zsbt{
    height: 120px;
    box-sizing: border-box;
    padding-top: 30px;
    overflow: hidden;
    box-shadow: 0 5px 5px -5px rgba(0, 0, 0, .3);
    text-align: center;
  }
  .zsbt div{
    height: 30px;
    margin-bottom: 10px;
  }
  .zsbt p{
    font-size: 16px;
  }
  h5{
    text-align: center;
    font-size: 16px;
    padding: 25px 0 15px;
  }
  .abs{
    padding:  0 10px;
  }
  .abs p{
    text-indent: 2em;
    font-size: 13px;
    line-height: 23px;
    letter-spacing: 1px;
  }
  .contact{
    background-color: white;
    margin: 30px 10px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .3);
    padding: 0 30px 30px 20px;
  }
  .contact h5{
    color: #1797b8;
  }
  .contact p{
    margin-bottom: 15px;
  }
  .product ul{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px;
  }
  .liItemR{
    position: relative;
    width: 172.5px;
    padding: 20px;
    margin-bottom: 10px;
    background-color: white;
    box-sizing: border-box;
    border-radius: 5px;
  }
  .liItemR>div{
    width: 132.5px;
    height: 132.5px;
  }
  .liItemR>p{
    text-align: center;
    padding-top: 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .liItemR>i{
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 21px;
    color: #dcdcdc;
  }


  .footer{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    text-align: center;
    display: flex;
    justify-content: space-around;
    box-shadow: 0 5px 5px 5px rgba(0, 0, 0, .3) ;
  }
  .footer li{
    padding-top: 3px;
    list-style: none;
    width: 50%;
    border-left: 1px solid white;
    background-color: #f3f3f3;
  }
  .footer li :first-child{
    border: none;
  }
  .footer li div{
    width: 27px;
    margin: 0 auto;
  }
  .footer li i{
    margin: 0 auto;
    font-size: 27px;
    display: block;
    color: #8b8a8a;
  }
  .footer li .hue{
    color: #ff840c;
  }
</style>